export const getRatingColor = (rating: string) => {
  return {
    A: "text-green-600",
    B: "text-yellow-500",
    C: "text-red-500",
  }[rating.slice(0, 1)];
};
